// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface ShareMegaphoneIconSignature {
  Element: SVGSVGElement;
}

export const ShareMegaphoneIcon: TOC<ShareMegaphoneIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M17.758 4.029C18.054 3.954 18.372 4.022 18.615 4.211C18.857 4.4 19 4.691 19 5V17C19 17.308 18.857 17.598 18.615 17.787C18.438 17.926 18.221 18 18 18C17.919 18 17.838 17.99 17.758 17.97L7 15.281V16.666L9.8 20.4L8.2 21.6L5.2 17.6C5.07 17.426 5 17.217 5 17V15H3C1.896 15 1 14.102 1 13V9C1 7.896 1.896 7 3 7H5.877L17.758 4.029ZM5 9H3V13H5V9ZM17 15.719L7 13.219V8.781L17 6.281V15.719ZM20 13.815V8.184C21.162 8.598 22 9.697 22 11.001C22 12.301 21.162 13.401 20 13.815Z"/>
</svg>
</template>;